import styled from "styled-components";
import { getThemeSpace } from "../helpers";
export const BreadcrumbsContainer = styled.div `
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: ${getThemeSpace("4")};
	color: var(--text-link);

	* {
		color: var(--text-link);
	}

	> a {
		text-decoration: underline;
		color: var(--text-link);
	}
`;
//# sourceMappingURL=styles.js.map